module.exports = __webpack_public_path__ + "static/media/1O2A0802 (1).4ad54f26.jpg";